<template>
    <div class="proposal-table px-3">
        <b-table-simple responsive bordered class="table-sm">
            <b-thead>
                <b-tr>
										<b-th class="align-middle text-center" v-if="is_editable"></b-th>
                    <b-th class="align-middle text-center">No.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 150px;">Type</b-th>
                    <b-th class="align-middle text-center" style="min-width: 130px;">Value</b-th>
                    <b-th class="align-middle text-center" style="min-width: 200px;">Description</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in tableData" :key="index">
										<b-td class="align-middle" v-if="is_editable">
											<el-button type="danger" size="mini" @click="deleteHandler(index)" icon="fa fa-times" circle></el-button>
										</b-td>
                    <b-td class="align-middle text-center">{{ index + 1 }}</b-td>
                    <b-td class="align-middle input-cell">
											<el-select v-model="item.pfee_type" placeholder="Select" size="mini" @change="setDescription(index,$event)">
													<el-option
													v-for="optItem in typeOptions"
													:key="optItem.id"
													:label="optItem.text"
													:value="optItem.value">
													</el-option>
											</el-select>
                    </b-td>
                    <b-td class="align-middle input-cell">
                        <b-form-input type="text" v-model="item.pfee_outstanding" @keydown="_gHlp.checkNonNumericInput" size="mini"></b-form-input>
                    </b-td>
                    <b-td class="align-middle input-cell">
                        <b-form-input type="text" v-model="item.pfee_description" size="mini"></b-form-input>
                    </b-td>
                </b-tr>
            </b-tbody>
            <b-tfoot>
                <b-tr class="font-weight-600">
										<b-td :colspan="is_editable ? 3 : 2">
												Summary
                    </b-td>
                    <b-td>{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.pfee_outstanding)) ? 0 : parseFloat(item.pfee_outstanding)), 0) | moneyFormatter }}</b-td>
                    <b-td></b-td>
								</b-tr>
            </b-tfoot>
        </b-table-simple>

        <div class="d-flex justify-content-between" v-if="is_editable">
					<el-button size="mini" type="info" icon="fa fa-plus" @click="addFeesCharge"> Add Fees & Charges</el-button>
					<el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
				</div>
    </div>
</template>
<script>
import { Select, Option, Button } from 'element-ui'
import {PROPOSED_REPAYMENT_VIAS} from '@/assets/js/status.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { isEqual, cloneDeep } from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'


export default {
		props: ['psal_id','psal_invinity_id','is_editable'],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
    },
    data() {
        return {
            PROPOSED_REPAYMENT_VIAS:PROPOSED_REPAYMENT_VIAS,
            tableData: [],
						typeOptions: [],
            originalTableData: [],
            is_updated: false,
            is_loading: false,
        }
    },
		created(){
			this.initComponent()
		},
    watch: {
			psal_id: {
				handler(newVal) {
					if(!_gHlp.isEmpty(newVal)){
						this.getListing(newVal)
					}
				},
				immediate: true,
			}
		},
    methods: {
				...mapActions(useInvinityStore, ['getDropdownList','syncToLms']),
				...mapActions(useInitialProposalStore, ['getFeesChargesList','bulkUpSertFeesCharges']),
				initComponent(){
					this.getDropdownList('lec_other_payment').then(resp => {
						this.typeOptions = resp
					})
				},
				getListing(psal_id){
					this.tableData = []
					this.originalTableData = []
					let params = {
						search:{
							pfee_psal_id: psal_id,
						},
						paginate:'no_paginate'
					}
					this.getFeesChargesList(params).then(resp => {
						this.tableData = _gHlp.getValue(resp,'data',[]);
						this.originalTableData = cloneDeep(this.tableData);
					}).catch(e => {
						_gNotif.errorFunction(e)
					})
				},
        async update(){
						this.is_loading = true
						if(await this.bulkUpSertFeesCharges(this.psal_id, this.tableData, this.originalTableData, !_gHlp.isEmpty(this.psal_invinity_id))){
							_gNotif.notifySuccess('<b>Fees And Charges</b> - Successfully Updated.')
							initialProposalEventBus.$emit('refresh-proposal-detail')
						}
						this.is_loading = false
        },
        addFeesCharge(){
            this.tableData.push({
                is_new: true,
                pfee_type: '',
                pfee_outstanding: '',
                pfee_description: ''
            })
        },
				setDescription(idx,value){
					const type = this.typeOptions.find(itm => itm.value === value);
					this.tableData[idx].pfee_description = _gHlp.getValue(type,'description');
				},
        deleteHandler(index){
          this.tableData.splice(index, 1)
        }
    }
}
</script>